import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b560}px) {
    width: 70%;
  }

  &.price-and-miles {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${Breakpoints.b560}px) {
      width: 30%;
      text-align: right;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
    }
  }
`;

export const StyledName = styled.div`
  width: 100%;
  font-family: 'vw-head';
  font-size: 17px;

  @media (min-width: ${Breakpoints.b960}px) {
    font-size: 32px;
  }
`;

export const StyledYear = styled.span`
  font-weight: 700;
`;

export const StyledModelName = styled.span`
  font-weight: 400;
`;

export const StyledModelNameTrim = styled.p`
  line-height: 32px;
  margin: 0;

  @media (min-width: ${Breakpoints.b960}px) {
    line-height: 44px;
  }
`;

export const StyledModelTrim = styled.span`
  font-weight: 300;
`;

export const StyledVin = styled.div`
  font-size: 12px;
  line-height: 36px;
  color: #6a767d;

  @media (min-width: ${Breakpoints.b560}px) {
    font-size: 16px;
  }
`;

export const StyledPrice = styled.div`
  font-size: 24px;
  font-weight: 700;
  font-family: 'vw-head';
  line-height: 40px;

  @media (min-width: ${Breakpoints.b960}px) {
    font-size: 32px;
    margin-bottom: 10px;
  }
`;

export const StyledDistance = styled.div`
  color: #001E50;
  font-size: 14px;
  font-weight: 700;
  line-height: 32px;

  @media (min-width: ${Breakpoints.b960}px) {
    font-size: 16px;
  }
`;
